export const staticData = {
  header: {
    logoLink: process.env.ENVIRONMENT === 'production' ? 'https://www.homeserve.co.uk' : 'https://www.reghomeserve.co.uk',
    headerLinks: [
      { id: '1', text: 'HOME COVER & SERVICES', url: '' },
      {
        id: '2',
        text: 'ABOUT HOMESERVE',
        url: process.env.ENVIRONMENT === 'production' ? 'https://www.homeserve.co.uk/about/about-us' : 'https://www.reghomeserve.co.uk/about/about-us',
      },
      {
        id: '3',
        text: 'GO TO ANGLIAN WATER DIRECT',
        url: 'https://awdirect.co.uk/',
      }
    ]
  },
  footer: {
    logo: '',
    footerLinks: [
      {
        id: '1',
        url: process.env.ENVIRONMENT === 'production' ? 'https://www.homeserve.co.uk/about/privacy-policy' : 'https://www.reghomeserve.co.uk/about/privacy-policy',
        footerText: 'Privacy Policy',
      },
      {
        id: '2',
        url: process.env.ENVIRONMENT === 'production' ? 'https://www.homeserve.co.uk/about/cookies' : 'https://www.reghomeserve.co.uk/about/cookies',
        footerText: 'Cookies Policy',
      },
      {
        id: '3',
        url: process.env.ENVIRONMENT === 'production' ? 'https://www.homeserve.co.uk/about/terms-of-use' : 'https://www.reghomeserve.co.uk/about/terms-of-use',
        footerText: 'Terms of Use',
      },
      {
        id: '4',
        url: process.env.ENVIRONMENT === 'production' ? 'https://www.homeserve.co.uk/about/anti-slavery-statement' : 'https://www.reghomeserve.co.uk/about/anti-slavery-statement',
        footerText: 'Anti-Slavery Statement',
      },
      {
        id: '5',
        url: process.env.ENVIRONMENT === 'production' ? 'https://www.homeserve.co.uk/about/gender-pay' : 'https://www.reghomeserve.co.uk/about/gender-pay',
        footerText: 'Gender pay',
      }
    ],
    footerLegalText:
      '<p>HomeServe is a trading name of HomeServe Membership Limited. Authorised and regulated by the Financial Conduct Authority for its general insurance activities. Registered in England and Wales, number 2770612. Registered office: Cable Drive, Walsall, WS2 7BN. VAT registration number GB 559669669.</p>',
  },
};
